export const getViewportDevice = () => {
  const width = window.innerWidth;
  if (width < 475) return "mobile";
  // else if (width < 1024) return "tablet";
  else return "desktop";
};
